/* Timber custom: cookie-consent UX shims (July 2026).
   Shopify's Customer Privacy preferences modal binds its Escape handler to the
   dialog element itself, so Esc only works while focus sits inside the dialog
   (click any dead space and it stops responding), and the backdrop overlay has
   no click-to-close at all. These document-level shims close the modal through
   its own close button, so Shopify's focus restore, body scroll unlock, and
   consent interaction logging all still run. The visual skin lives at the end
   of base.css (grep "Timber custom: cookie consent skin"). */
(function () {
  'use strict';

  function prefsOpen() {
    var wrapper = document.getElementById('shopify-pc__prefs');
    return Boolean(wrapper) && window.getComputedStyle(wrapper).display !== 'none';
  }

  function closePrefs() {
    var close = document.getElementById('shopify-pc__prefs__header-close');
    if (close) close.click();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    /* If focus was inside the dialog, Shopify's own handler has already closed
       it by the time this bubbles up — prefsOpen() is then false and we skip. */
    if (!prefsOpen()) return;
    e.preventDefault();
    closePrefs();
  });

  document.addEventListener('click', function (e) {
    if (!prefsOpen()) return;
    var overlay = document.getElementById('shopify-pc__prefs__overlay');
    if (overlay && e.target === overlay) closePrefs();
  });
})();
